import React from 'react';

function Schedule(props) {
    return (
        <div>Schedule</div>
    );
}

export default Schedule;